import { AccountsFilters } from './types';
import { FilterOption } from '../../../components/ui';

export const DEFAULT_FILTERS: AccountsFilters = {
  search: '',
  status: '',
  source: '',
};

export const getSourceFilterOptions = (t: (key: string) => string): FilterOption[] => [
  { key: 'all', label: t('partner.partnerAccounts.allSources') || 'Все источники' },
  { key: 'cpl', label: 'CPL' },
  { key: 'refshare', label: 'RevShare' },
];

export const DEFAULT_PAGE_SIZE = 10;
export const SEARCH_DEBOUNCE_DELAY = 500;

// API status values: verified, wait_media, moderation, active, deactivated
export const getStatusFilterOptions = (t: (key: string) => string): FilterOption[] => [
  { key: 'active', label: t('partner.partnerAccounts.statusActive') },
  { key: 'deactivated', label: t('partner.partnerAccounts.statusDeactivated') },
  { key: 'moderation', label: t('partner.partnerAccounts.statusModeration') },
];

export const getTableColumns = (t: (key: string) => string) => [
  { name: t('partner.partnerAccounts.accountColumn') || 'Аккаунт', key: 'id' },
  { name: t('partner.partnerAccounts.summary'), key: 'summary' },
  { name: t('partner.partnerAccounts.indicators'), key: 'indicators' },
  { name: t('partner.partnerAccounts.status'), key: 'status' },
  { name: t('partner.partnerAccounts.actions'), key: 'actions' },
];

export const getStatusLabels = (t: (key: string) => string) => ({
  active: t('partner.partnerAccounts.statusActive'),
  deactivated: t('partner.partnerAccounts.statusDeactivated'),
  moderation: t('partner.partnerAccounts.statusModeration'),
  wait_media: t('partner.partnerAccounts.statusWaitMedia'),
  verified: t('partner.partnerAccounts.statusVerified'),
});

// Dot color for status badges (matching Figma design)
export const getStatusDotColor = (status: string): string => {
  switch (status) {
    case 'active':
      return 'bg-success';
    case 'deactivated':
      return 'bg-neutral-500';
    case 'moderation':
      return 'bg-accent';
    case 'wait_media':
      return 'bg-warning';
    case 'verified':
      return 'bg-yellow-600';
    default:
      return 'bg-auth-muted';
  }
};
